<template>
	<button class="submit" :class="{ busy, wide }" v-bind="bind">
		{{ label }}
	</button>
</template>

<script>
export default {
	name: 'SubmitButton',
	props: {
		label: {
			type: String,
			default: 'Submit',
		},
		wide: {
			type: Boolean,
			default: false,
		},
		invalid: {
			type: Boolean,
			default: false,
		},
		busy: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		bind() {
			return {
				type: 'submit',
				disabled: this.invalid,
				busy: this.busy,
			}
		},
	},
}
</script>

<style lang="scss" scoped>
@import '~scss/components';
@import '~scss/mq';

.submit {
	@include button--large;
	width: 100%;

	&.busy {
		& {
			color: transparent;
		}
		&::after {
			@include spinner--centered(1.75rem, $white);
			content: '';
			position: absolute;
			top: 50%;
			left: 50%;
		}
	}

	@include mq(md) {
		&:not(.wide) {
			width: auto;
		}
	}
}
</style>
